import React from "react";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core";
import Close from "@material-ui/icons/Close";
import ErrorOutline from "@material-ui/icons/ErrorOutline";
import HelpOutline from "@material-ui/icons/HelpOutline";

const styles = {
    supportIcon: {
        width: "3em",
        height: "3em",
        color: "#fff",
        marginLeft: 24,
    },
    titleContainer: {
        backgroundColor: "#00abec",
        textAlign: "center",
    },
    titleContainer2: {
        backgroundColor: "#00abec",
        textAlign: "center",
    },
    questionTitle: {
        marginTop: ".6em",
        color: "#00abec",
        fontWeight: 500,
    },
    nooverflow: {
        overflow: "hidden",
        minWidth: 375,
    },
    greyButton: {
        backgroundColor: "#808080",
        color: "#fff",
    },
    centerButtons: {
        justifyContent: "center",
        marginTop: 24,
    },
    closeIcon: {
        float: "right",
        color: "#fff",
        marginTop: -16,
        marginRight: -16,
    },
};

const HelpDialog = ({ question, text, classes, confirmAction, cancelAction, confirmText, cancelText, onClose, showErrorOutline, ...other }) => (
    <Dialog onClose={onClose} {...other} classes={{ paper: classes.nooverflow }}>
        <DialogTitle className={showErrorOutline ? classes.titleContainer2 : classes.titleContainer}>
            {showErrorOutline && <ErrorOutline className={classes.supportIcon} />}
            {!showErrorOutline && <HelpOutline className={classes.supportIcon} />}
            <IconButton onClick={onClose} className={classes.closeIcon}>
                <Close />
            </IconButton>
        </DialogTitle>
        <DialogContent>
            <Typography variant="h5" className={classes.questionTitle} gutterBottom>
                {question}
            </Typography>
            {typeof text !== "string" ? (
                <DialogContentText style={{ whiteSpace: "pre-line" }}>{text}</DialogContentText>
            ) : (
                <DialogContentText style={{ whiteSpace: "pre-line" }}>
                    <div dangerouslySetInnerHTML={{ __html: text }} />
                </DialogContentText>
            )}
            {confirmAction && (
                <DialogActions className={classes.centerButtons}>
                    <Button onClick={confirmAction} color="secondary" variant="raised">
                        {confirmText ? confirmText : "Ok"}
                    </Button>
                    <Button onClick={cancelAction} variant="raised" className={classes.greyButton} autoFocus>
                        {cancelText ? cancelText : "Cancel"}
                    </Button>
                </DialogActions>
            )}
            {!confirmAction && (
                <DialogActions className={classes.centerButtons}>
                    <Button onClick={onClose} color="secondary" variant="raised">
                        Ok
                    </Button>
                </DialogActions>
            )}
        </DialogContent>
    </Dialog>
);

export default withStyles(styles)(HelpDialog);
